/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect, useMemo } from "react";
import {
  Grid,
  Container,
  Button,
} from "@material-ui/core";
import PageTitle from "../../components/pageTitle/PageTitle";
import CommonContext from "../../hooks/commonContext";
import { Bell, Mail, MessageSquare } from "lucide-react";
import { getGroupsList } from "../../services/apiservices/groups";
import {
  getEmployeesList,
} from "../../services/apiservices/employee";
import confirm from "../../components/DialogComponent/confirm";
import { useNavigate } from "react-router";
import { saveNotification } from "../../services/apiservices/notifications";
import AuthContext from "../../hooks/authContext";
import { getSettings, saveSettings, subscribeToSettings, updateSettings } from "../../services/apiservices/settings";
import { packageAccess } from "../../services/helpers";
import { useMediaQuery } from "@mui/material";
import { useToast } from "../../hooks/useToast";
import { trackEvent, CMS_EVENTS } from "../../services/apiservices/analytics";
import NotificationForm from "./NotificationForm";
import { Checkbox } from "../../components/ui/checkbox";
import { Label } from "../../components/ui/label";
import { getSmsCharacterInfo, getSmsCounterStatus } from "../../components/ui/smsUtils";
import { CommonConfirmationDialog } from "../../components/DialogComponent/SupplyDataDialog";

function CreateNotification(props) {
  const commonContext = useContext(CommonContext);
  const history = useNavigate();
  const { toast } = useToast();
  const [formerror, setFormError] = useState({});
  const [formdata, setFormData] = useState({});
  const [type, setType] = useState("employee");
  const [audienceList, setAudienceList] = useState([]);
  const [audienceName, setAudienceName] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [, setGetEmpby] = useState(false);
  const [, setGetCliby] = useState(true);
  const [scheduled, setSCheduled] = useState(false);
  const [scheduleTime, setScheduleTime] = useState();
  const [scheduleDate, setScheduleDate] = useState();
  const [clientList, setClientList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [messageOptionsList, setMessageOptionsList] = useState([]);
  const [notificationLimits, setNotificationLimits] = useState();
  const [consentConfirmed, setConsentConfirmed] = useState(false);
  const [SMSLimitReached, setSMSLimitReached] = useState(false);
  const setIsLoading = (status) => {
    commonContext.setLoader(status);
  };
  const isMobile = useMediaQuery("(max-width:767px)");
  const auth = useContext(AuthContext);
  const localCompanyId = localStorage.getItem('companyId');
  const companyId = auth?.userProfile?.role === "Client" ? localCompanyId ? localCompanyId : auth?.userProfile?.companyId : auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const userPackageId = auth?.userProfile?.prdId;
  const userPromocode = auth?.userProfile?.userPromoCode || auth?.userProfile?.companyData?.userPromoCode;
  const subscriptionId = auth?.userProfile?.subscriptionDetails?.scheduleId || auth?.userProfile?.subscriptions?.data?.[0]?.scheduleId;
  const allowedPermissions = packageAccess(userPackageId, userPromocode, subscriptionId);
  const hasSMSAccess = allowedPermissions?.routes?.includes("SMS_NOTIFICATION");
  const companyName = `${auth?.userProfile?.companyData?.data?.companyName}`;
  const selectedNotificationTypes = formdata?.selectedMessageType || [];
  const isSmsSelected = selectedNotificationTypes.includes("Push");
  const smsPackageLimits = notificationLimits?.smsPackageLimits || allowedPermissions?.messageLimits || 0;
  const smsRemainingAllowance = (smsPackageLimits ?? 0) - (notificationLimits?.smsRemainingAllowance ?? 0);
  const selectedRecipients = type === "employee" ? formdata?.selectedEmployees || [] : type === "group" ? formdata?.selectedGroup ? formdata.selectedGroup : [] : [];

  const smsInfo = useMemo(() => getSmsCharacterInfo(formdata?.message || ""), [formdata?.message]);
  const status = useMemo(() => getSmsCounterStatus(smsInfo), [smsInfo]);

  const totalSegmentsNeeded = smsInfo?.segmentCount * (selectedRecipients?.length || 1);
  const wouldExceedLimit = totalSegmentsNeeded > smsRemainingAllowance;
  const projectedRemaining = Math.max(0, smsRemainingAllowance - totalSegmentsNeeded);
  const isSmsLimitReached = smsRemainingAllowance <= 0 || (smsRemainingAllowance - totalSegmentsNeeded < 0);

  const clearformdata = () => {
    setFormData({});
    setFormError({});
    setGetEmpby("");
    setGetCliby("");
    setSCheduled(false);
    setScheduleDate();
    setScheduleTime();
    setAudienceList([]);
    setAudienceName([]);
  };

  const resetFormStates = () => {
    setFormError({});
    setFormData({});
    setType("employee");
    setAudienceList([]);
    setAudienceName([]);
    setGetEmpby(false);
    setGetCliby(true);
    setSCheduled(false);
    setScheduleTime(undefined);
    setScheduleDate(undefined);
    setClientList([]);
    setGroupList([]);
    setEmployeeList([]);
    setMessageOptionsList([]);
  };

  const fetchData = async () => {
    setIsLoading(true);
    let Emps = [];
    await getEmployeesList(
      {},
      (res) => {
        if (res) {
          const details = res?.filter((item) => item?.companyId === companyId && item?.status !== false);
          setEmployees(details);
          const data = res?.filter((item) => {
            const isActive = item?.status !== false;
            const isSameCompany = item?.companyId === companyId;
            if (!isActive || !isSameCompany) return false;
            return true;
          });
          Emps = data;
          let allEmp = data?.map((eitem) => {
            return {
              ...eitem,
              userName: `${eitem?.firstName} ${eitem?.lastName}`,
            };
          });
          setEmployeeList(allEmp);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      },
      (resError) => {
        console.log("reserror", resError);
        setIsLoading(false);
      }
    );
    getGroupsList(
      {},
      (res) => {
        if (res) {
          const data = res?.filter((item) => {
            const isSameCompany = item?.companyId === companyId;
            if (!isSameCompany) return false;
            return true;
          });
          setGroupList(data);
          setIsLoading(false);
        }
      },
      (resError) => {
        setIsLoading(false);
      }
    );
  };

  useEffect(() => {
    setIsLoading(true);
    clearformdata();
    setAudienceList([]);
    setAudienceName([]);
    fetchData();

    getSettings("notification_settings", companyId, (res) => {
      const userRole = auth?.userProfile?.role;
      const employeeRole = auth?.userProfile?.employeerole;
      const isFullAccess = userRole === "companyUser" || ((Array.isArray(userRole) && userRole.includes("Employee")) || userRole === "Employee" && (employeeRole === "Admin" || employeeRole === "Support"));

      const defaultOptions = [
        {
          label: "Push Notification",
          value: "PushNotification",
          icon: <Bell size={16} />,
          enabled: false,
        },
        {
          label: "SMS",
          value: "Push",
          icon: <MessageSquare size={16} />,
          enabled: false,
        },
        {
          label: "Email",
          value: "Email",
          icon: <Mail size={16} />,
          enabled: false,
        },
      ];

      const setOptions = (data) => {
        const updatedOptions = defaultOptions?.map((opt) => {
          let isEnabled = false;

          if (isFullAccess) {
            isEnabled = true;
          } else {
            if (opt?.value === "PushNotification") {
              isEnabled = data?.pushNotificationRoles?.includes(userRole);
            } else if (opt?.value === "Push") {
              isEnabled = hasSMSAccess && data?.smsRoles?.includes(userRole);
            } else if (opt?.value === "Email") {
              isEnabled = data?.emailRoles?.includes(userRole);
            }
          }

          return {
            ...opt,
            enabled: isEnabled,
          };
        });

        setMessageOptionsList(updatedOptions);
        setIsLoading(false);
      };

      if (res?.data?.length > 0) {
        const filteredData = res?.data?.filter(
          (item) => !item.deleted
        );
        if (filteredData.length > 0) {
          setOptions(filteredData[0]);
          return;
        }
      }

      setMessageOptionsList(
        defaultOptions.map((opt) => ({ ...opt, enabled: true }))
      );
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    getaudience();
  }, [formdata?.selectedGroup]);

  useEffect(() => {
    getaudienceCli();
  }, [formdata?.selectedClient]);

  useEffect(() => {
    const unsubscribe = subscribeToSettings(
      companyId,
      "notification_limits",
      (newSettings) => {
        setNotificationLimits(newSettings);
        setConsentConfirmed(newSettings?.checked || false);
      },
      (err) => console.log(err)
    );

    return () => unsubscribe && unsubscribe();
  }, [companyId]);

  const handlefieldChange = (name, value) => {
    setFormData({
      message: formdata?.message,
      subject: formdata?.subject,
      selectedMessageType: formdata?.selectedMessageType,
      [name]: value,
    });
    setFormError({ ...formerror, [name]: "" });
    if (name === "selectedClient") {
      setGetEmpby("client");
      setGetCliby("clientt");
    }
    if (name === "selectedEmployees" && value) {
      setGetEmpby("employee");
      setAudienceList([
        ...value?.map((aitem) => {
          return {
            name: aitem.firstName,
            id: aitem.id,
            email: aitem.email,
            phone: aitem.phoneNumber,
          };
        }),
      ]);
    }
  };

  const handlefieldChangenew = (name, value) => {
    setFormData({ ...formdata, [name]: value });
    setFormError({ ...formerror, [name]: "" });
    // if (name === "selectedClient") {
    //   setGetEmpby("client");
    //   setGetCliby("clientt");
    // }
    // if (name === "selectedEmployees" && value) {
    //   setGetEmpby("employee");
    //   setAudienceList([
    //     ...value?.map((aitem) => {
    //       return {
    //         name: aitem.firstName,
    //         id: aitem.id,
    //         email: aitem.email,
    //         phone: aitem.phoneNumber,
    //       };
    //     }),
    //   ]);
    // }
  };

  const handlefieldChangenewm = (name, value) => {
    setFormData({ ...formdata, [name]: value });
    setFormError({ ...formerror, [name]: "" });
    // if (name === "selectedClient") {
    //   setGetEmpby("client");
    //   setGetCliby("clientt");
    // }
    // if (name === "selectedEmployees" && value) {
    //   setGetEmpby("employee");
    //   setAudienceList([
    //     ...value?.map((aitem) => {
    //       return {
    //         name: aitem.firstName,
    //         id: aitem.id,
    //         email: aitem.email,
    //         phone: aitem.phoneNumber,
    //       };
    //     }),
    //   ]);
    // }
  };
  const getaudienceCli = () => {
    const { selectedClient } = formdata;

    if (Array.isArray(selectedClient)) {
      let list;
      const data =
        auth?.userProfile?.role === "Client"
          ? employees?.filter((employee) =>
            employee?.clients?.some(
              (client) => client?.clientid === auth?.userProfile?.client
            )
          )
          : employees;

      const selectedClientIds = selectedClient?.map((c) => c.id);

      list = Array.isArray(data)
        ? data
          .map((aitem) => {
            const clientIds = Array.isArray(aitem?.clients)
              ? aitem.clients.map((clien) => clien?.clientid)
              : [];

            const hasMatch = clientIds?.some((id) =>
              selectedClientIds?.includes(id)
            );

            if (hasMatch) {
              return {
                name: aitem.firstName,
                id: aitem.id,
                email: aitem.email,
                phone: aitem.phoneNumber,
              };
            }

            return null;
          })
          .filter(Boolean)
        : [];

      const newlist = list?.filter((value) => Object.keys(value)?.length !== 0);

      setAudienceList(newlist);
    }
  };

  const getaudience = () => {
    const { selectedGroup } = formdata;

    if (Array.isArray(selectedGroup)) {
      let list;
      const data = employees;

      const selectedGroupIds = selectedGroup?.map((g) => g?.groupId);

      list = Array.isArray(data)
        ? data
          ?.map((aitem) => {
            const userGroups = aitem?.group || [];

            const hasMatch = userGroups?.some((id) =>
              selectedGroupIds?.includes(id)
            );

            if (hasMatch) {
              return {
                name: aitem.firstName,
                id: aitem.id,
                email: aitem.email,
                phone: aitem.phoneNumber,
              };
            }

            return null;
          })
          .filter(Boolean)
        : [];

      const newlist = list?.filter((value) => Object.keys(value)?.length !== 0);

      setAudienceList(newlist);
    }
  };

  const checkValid = () => {
    let errormessages = formerror;
    let isValid = true;
    if (typeof formdata?.message === "undefined" || formdata?.message === "") {
      isValid = false;
      toast({
        title: "Error",
        description: "Please enter a message",
        variant: "destructive",
      });
      errormessages = {
        ...errormessages,
        message: "Field is required",
      };
    } else {
      errormessages = { ...errormessages, message: "" };
    }
    if (audienceList.length <= 0) {
      isValid = false;
      toast({
        title: "Error",
        description: "Please select at least one recipient",
        variant: "destructive",
      });
      errormessages = {
        ...errormessages,
        selectedGroup: "Please Add employees By Name/By Client/By Group First!",
      };
    } else {
      errormessages = { ...errormessages, selectedGroup: "" };
    }

    if (
      typeof formdata?.selectedMessageType === "undefined" ||
      formdata?.selectedMessageType === ""
    ) {
      isValid = false;
      errormessages = {
        ...errormessages,
        selectedMessageType: "Field is required",
      };
    } else {
      errormessages = { ...errormessages, selectedMessageType: "" };
    }

    if (isSmsSelected && !consentConfirmed) {
      isValid = false;
      toast({
        title: "Error",
        description: "You must confirm that you have obtained consent from recipients to receive SMS messages.",
        variant: "destructive",
      });
      errormessages = {
        ...errormessages,
        consentRequired: "You must confirm that you have obtained consent from recipients to receive SMS messages.",
      };
    } else {
      errormessages = { ...errormessages, consentRequired: "" };
    }

    setFormError(errormessages);
    return isValid;
  };

  const saveNotificationData = async () => {
    setIsLoading(true);
    const filteredMessageTypes = (formdata?.selectedMessageType || [])?.filter(
      (type) => {
        if (type === "Push") {
          return !isSmsLimitReached;
        }
        return true;
      }
    );

    const allTypesPresent = ["PushNotification", "Push", "Email"].every(
      (type) => formdata?.selectedMessageType.includes(type)
    );
    let formDataSave = {
      Message: formdata?.message,
      scheduled: scheduled,
      scheduleDate: scheduled ? scheduleDate : null,
      scheduleTime: scheduled ? scheduleTime : null,
      subject: formdata?.subject,
      companyId: companyId,
      Client: Array.isArray(formdata?.selectedClient)
        ? formdata?.selectedClient?.map((client) => ({
          id: client?.id,
          name: client?.clientName,
        }))
        : [],

      Group: Array.isArray(formdata?.selectedGroup)
        ? formdata?.selectedGroup?.map((group) => ({
          id: group?.groupId,
          title: group?.title,
        }))
        : [],
      Type: allTypesPresent ? "Both" : filteredMessageTypes,
      read: false,
      Employee: audienceList
        ? audienceList?.map((empitem) => {
          return {
            id: empitem.id,
            name: `${empitem.name}`,
            email: empitem.email,
            phone: empitem.phone,
          };
        })
        : [],
      MessageRecipents: audienceList
        ? audienceList?.map((aitem) => aitem.id)
        : [],
    };

    const dataToSave = {
      companyId,
      smsRemainingAllowance: (notificationLimits?.smsRemainingAllowance ?? 0) + totalSegmentsNeeded,
      notificationCount: (notificationLimits?.notificationCount ?? 0) + totalSegmentsNeeded,
      // checkedBy: {
      //   id: auth?.userProfile?.id,
      //   name: `${auth?.userProfile?.firstName} ${auth?.userProfile?.lastName}`,
      // },
      // checked: consentConfirmed,
      smsPackageLimits: smsPackageLimits,
      lastUpdatedBy: auth?.userProfile?.id,
    };
    const dataToUpdate = {
      smsRemainingAllowance: (notificationLimits?.smsRemainingAllowance ?? 0) + totalSegmentsNeeded,
      notificationCount: (notificationLimits?.notificationCount ?? 0) + totalSegmentsNeeded,
      smsPackageLimits: smsPackageLimits,
      lastUpdatedBy: auth?.userProfile?.id,
    };
    if (isSmsSelected && notificationLimits) {
      updateSettings(dataToUpdate, "notification_limits", notificationLimits?.id);
    } else if (isSmsSelected) {
      saveSettings(dataToSave, "notification_limits");
    }

    saveNotification(
      formDataSave,
      companyName,
      (res) => {
        if (res.status === true) {
          setIsLoading(false);
          toast({
            title: "Success",
            description: scheduled
              ? "Your notification has been scheduled"
              : "Your notification has been sent",
            variant: "default",
          });

          resetFormStates();
          history("/communications/notifications/manage");
          trackEvent(CMS_EVENTS.NOTIFICATION_CREATED, {
            notification_type: allTypesPresent ? "Both" : filteredMessageTypes,
            is_scheduled: scheduled,
          });
        }
      },
      (errorRes) => {
        setIsLoading(false);
        toast({
          title: "Error",
          description: errorRes?.error?.response?.data?.error,
          variant: "destructive",
        });
        console.log("error while save notification", errorRes);
      }
    );
  };

  const onSaveNotification = () => {
    if (true === checkValid()) {
      setIsLoading(true);
      if (!formdata?.selectedMessageType) {
        toast({
          title: "Error",
          description: "Please select at least one notification type",
          variant: "destructive",
        });
      }

      if (formdata?.selectedMessageType.includes("Push") && isSmsLimitReached) {
        setIsLoading(false);
        setSMSLimitReached(true);
        return;
      } else {
        saveNotificationData();
      }
    }
  };

  const handleNotificationConfirm = () => {
    setSMSLimitReached(false);
    saveNotificationData();
  };

  const handleCloseSMSLimitReached = () => {
    setSMSLimitReached(false);
    setIsLoading(false);
  };

  const onScheduledChange = () => {
    setSCheduled(!scheduled);
  };

  const onScheduledDateChange = (e) => {
    setScheduleDate(e);
  };
  const onScheduledTimeChange = (e) => {
    setScheduleTime(e);
  };

  useEffect(() => {
    if (audienceList?.length > 0) {
      const data = audienceList?.map((item) => item?.name);
      setAudienceName(data);
    } else {
      setAudienceName();
    }
  }, [audienceList]);

  let allclietnoptions = [
    ...clientList?.map((item) => {
      return { label: item?.clientName, value: item, employeeCount: item?.employeeCount };
    }),
  ];
  let allgroupoptions = [
    ...groupList?.map((item) => {
      return { label: item?.title, value: item };
    }),
  ];
  let allempoptions = employeeList?.map((item) => {
    return { label: item?.firstName + item?.lastName, value: item };
  });

  const handleNotificationTypeChange = (value) => {
    const newSelected = selectedNotificationTypes?.includes(value)
      ? selectedNotificationTypes?.filter((item) => item !== value)
      : [...selectedNotificationTypes, value];
    handlefieldChangenew("selectedMessageType", newSelected);
  };

  const handleSelectAllTypes = () => {
    const allowedTypes = messageOptionsList
      ?.filter((item) => item?.enabled)
      ?.map((item) => item.value);

    const selectableTypes = allowedTypes?.filter((type) => {
      if (type === "Push") return !isSmsLimitReached;
      return true;
    });

    const isAllSelected = selectableTypes?.every((type) =>
      selectedNotificationTypes?.includes(type)
    );

    if (isAllSelected) {
      handlefieldChangenew("selectedMessageType", []);
    } else {
      handlefieldChangenew("selectedMessageType", selectableTypes);
    }
  };

  const options =
    type === "client"
      ? allclietnoptions
      : type === "group"
        ? allgroupoptions
        : allempoptions;

  return (
    <Container>
      <PageTitle
        pageTitle="Create Notification"
        showBreadcrumb={[
          { label: "Home", to: "/" },
          {
            label: "Notifications",
            to: "/communications/notifications/manage",
          },
        ]}
        showLastSeen={true}
      />
      <div className="p-20">
        <NotificationForm
          isMobile={isMobile}
          type={type}
          options={options}
          formdata={formdata}
          audienceName={audienceName}
          setAudienceName={setAudienceName}
          selectedNotificationTypes={selectedNotificationTypes}
          messageOptionsList={messageOptionsList}
          scheduled={scheduled}
          scheduleDate={scheduleDate}
          scheduleTime={scheduleTime}
          smsPackageLimits={smsPackageLimits}
          isSmsLimitReached={isSmsLimitReached}
          smsRemainingAllowance={smsRemainingAllowance}
          smsInfo={smsInfo}
          status={status}
          totalSegmentsNeeded={totalSegmentsNeeded}
          wouldExceedLimit={wouldExceedLimit}
          projectedRemaining={projectedRemaining}
          setAudienceList={setAudienceList}
          setFormData={setFormData}
          setType={setType}
          handlefieldChange={handlefieldChange}
          handlefieldChangenewm={handlefieldChangenewm}
          handleNotificationTypeChange={handleNotificationTypeChange}
          handleSelectAllTypes={handleSelectAllTypes}
          onScheduledChange={onScheduledChange}
          onScheduledDateChange={onScheduledDateChange}
          onScheduledTimeChange={onScheduledTimeChange}
        />

        {/* {isSmsSelected && (
        <div className="flex mt-10 items-start space-x-3 p-16 bg-muted/50 rounded-lg border border-border">
          <Checkbox
            id="consent-attestation"
            checked={consentConfirmed}
            onCheckedChange={(checked) => setConsentConfirmed(checked === true)}
            className="mt-2"
          />
          <Label
            htmlFor="consent-attestation" 
            className="text-sm text-muted-foreground leading-relaxed cursor-pointer"
          >
            I confirm that I have obtained the required consent from recipients to receive messages.
          </Label>
        </div>
      )} */}

        <div className="ph-12">
          <Grid container className="buttonwrap mv-15">
            <Grid item sm={12} md={12}>
              <Button
                variant="contained"
                color={messageOptionsList.length > 0 ? "primary" : ""}
                className="themebutton flatbutton mr-12"
                onClick={onSaveNotification}
                style={{ borderRadius: "4px" }}
                disabled={messageOptionsList.length === 0}
              >
                Send Notification
              </Button>
              <Button
                color="primary"
                variant="contained"
                style={{ borderRadius: "4px" }}
                className="themebutton flatbutton mr-12"
                onClick={clearformdata}
              >
                Reset
              </Button>
              <Button
                variant="contained"
                style={{ borderRadius: "4px" }}
                className="themebutton flatbutton "
                onClick={async () => {
                  try {
                    const result = await confirm(
                      "Are you sure you want to cancel? This won't be saved or sent."
                    );

                    if (result) {
                      history("/communications/notifications/manage");
                    }
                  } catch (err) {
                    console.log("Dialog closed or error:", err);
                  }
                }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>

      {SMSLimitReached && (
        <CommonConfirmationDialog
          open={SMSLimitReached}
          onConfirm={handleNotificationConfirm}
          onClose={handleCloseSMSLimitReached}
          title={"SMS Limit Reached"}
          message="Your SMS limit has been reached, but you can still send Push notifications and Email. Are you sure you want to proceed?"
          buttonTitle={"Yes, send notification"}
        />
      )}
    </Container>
  );
}

export default CreateNotification;
